/* src/app/modules/cooling-companion/components/cooling-date-picker/cooling-date-picker.component.scss */
.mat-date-form-field {
  display: flex;
}
/*# sourceMappingURL=cooling-date-picker.component.css.map */
